import styled from 'styled-components';

export const ChartContainer = styled.div`
    background: #fff;
    padding: 24px;
    border-radius: 8px;
    box-shadow: 0px 3px 12px rgba(81, 69, 159, 0.08);
    min-width: 0;
    overflow-x: auto;
`;

export const ChartHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
`;

export const ChartTitle = styled.h3`
    font-size: 18px;
    font-weight: 700;
    color: #25272e;
    margin: 0;
`;

export const ChartInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    .year {
        font-size: 16px;
        font-weight: 600;
        color: #25272e;
    }

    .separator {
        color: #9ba1a9;
    }

    .total {
        font-size: 14px;
        color: #9ba1a9;
    }
`;
